<mzima-client-button
  tabindex="-1"
  fill="outline"
  [iconOnly]="true"
  color="light-gray"
  [data-qa]="'btn-close'"
  class="modal__close-btn"
  [mat-dialog-close]="false"
  ariaLabel="{{ 'modal.button.close' | translate }}"
>
  <mat-icon icon svgIcon="close"></mat-icon>
</mzima-client-button>

<strong mat-dialog-title>{{ 'nav.help_support' | translate }}</strong>

<div mat-dialog-content>
  <!-- Security & Privacy Section -->
  <div class="security-section">
    <p class="disclaimer">{{ 'app.disclaimer' | translate }}</p>
    <p class="section230">{{ 'app.disclaimer_section230' | translate }}</p>
    <div class="privacy-commitments">
      <p>{{ 'app.privacy_commitments' | translate }}</p>
    </div>
  </div>

  <!-- Dynamic Menu Items (if any) -->
  <div class="links-section" *ngIf="menu.length > 0">
    <div matRipple class="menu-item" (click)="item?.action()" *ngFor="let item of menu">
      <h4 class="menu-item__title">{{ item.title }}</h4>
      <p class="menu-item__description" *ngIf="item.description?.length">{{ item.description }}</p>
    </div>
  </div>

  <!-- Button Row Section -->
  <div class="button-row">
    <button mat-button class="action-button" (click)="openUrl('https://resistmap.com/legal#terms')">
      <mat-icon>description</mat-icon>
      <span>{{ 'app.terms_and_conditions' | translate }}</span>
    </button>

    <button
      mat-button
      class="action-button"
      (click)="openUrl('https://resistmap.com/legal#privacy')"
    >
      <mat-icon>shield</mat-icon>
      <span>{{ 'app.privacy_policy' | translate }}</span>
    </button>

    <!-- Volunteer / Staff Login for logged out users -->
    <button mat-button class="action-button login-button" (click)="openLogin()" *ngIf="!isLoggedIn">
      <mat-icon>login</mat-icon>
      <span>{{ 'nav.volunteer_staff_login' | translate }}</span>
    </button>

    <!-- Logout -->
    <button mat-button class="action-button login-button" (click)="logout()" *ngIf="isLoggedIn">
      <mat-icon>logout</mat-icon>
      <span>{{ 'nav.logout' | translate }}</span>
    </button>
  </div>

  <!-- Attributions Section -->
  <div class="attributions-section">
    <h3 class="section-title">{{ 'app.attributions' | translate }}</h3>
    <div class="attribution-list">
      <div class="attribution-item">
        <span class="attribution-label">Map Data:</span>
        <span class="attribution-value"
          >©
          <a href="https://openstreetmap.org" target="_blank" rel="noopener">OpenStreetMap</a>
          contributors</span
        >
      </div>
      <div class="attribution-item">
        <span class="attribution-label">Map Tiles:</span>
        <span class="attribution-value"
          >© <a href="https://www.mapbox.com/" target="_blank" rel="noopener">Mapbox</a></span
        >
      </div>
      <div class="attribution-item">
        <span class="attribution-label">Mapping Library:</span>
        <span class="attribution-value"
          ><a href="https://leafletjs.com/" target="_blank" rel="noopener">Leaflet</a></span
        >
      </div>
      <div class="attribution-item">
        <span class="attribution-label">Icons:</span>
        <span class="attribution-value"
          ><a href="https://fontawesome.com/" target="_blank" rel="noopener">Font Awesome</a></span
        >
      </div>
    </div>
  </div>
</div>
